import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import moment from "moment";
import DatePickerTextbox from "./DatePickerTextbox.vue";
import UserList from "@/types/User/UserList";
import CreateUserDialog from "./Modals/CreateUserDialog.vue";
import User from "@/types/User/User";
let ExternalSupportEditor = class ExternalSupportEditor extends Vue {
    fetchExternalSupport() {
        this.$data.filteredExternalSupport = null;
        this.$data.loadingExternalSupport = true;
        this.$store
            .dispatch("getExternalSupport")
            .then((result) => {
            this.$data.externalSupport = result.data;
            this.filterCurrentExternalSupport();
            this.$data.loadingExternalSupport = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalSupportEditor.vue - getExternalSupport");
        });
    }
    filterCurrentExternalSupport() {
        if (this.$data.onlyCurrentExternalSupport === true) {
            this.$data.filteredExternalSupport = this.$data.externalSupport.filter((externalSupport) => {
                return this.isCurrentExternalSupport(externalSupport);
            });
        }
        else {
            this.$data.filteredExternalSupport = this.$data.externalSupport;
        }
    }
    isCurrentExternalSupport(externalSupport) {
        return (moment(new Date()) <= moment(externalSupport.to) || externalSupport.to === null);
    }
    showCreateModal(item) {
        this.loadUsers();
        this.$data.selectedExternalSupportToCreate = null;
        this.$data.createExternalSupportDates = { from: null, to: null };
        this.$data.modals.createExternalSupport = true;
    }
    closeCreateModal() {
        this.$data.selectedExternalSupportToCreate = null;
        this.$data.userList = null;
        this.$data.modals.createExternalSupport = false;
        this.$data.selectedExternalSupportToCreate = null;
        this.$data.createExternalSupportDates = { from: null, to: null };
    }
    loadUsers() {
        this.$data.loadingUsers = true;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.loadingUsers = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue - loadUsers");
        });
    }
    showEditModal(item) {
        this.$data.selectedExternalSupport = item;
        this.$data.modals.editExternalSupport = true;
    }
    impersonateUser(userItem) {
        //Retrieve the user object
        this.$store
            .dispatch("getUser", userItem.userId)
            .then((result) => {
            const impersonateUser = new User(userItem);
            this.$store.dispatch("impersonateUser", impersonateUser);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue -> impersonateUser");
        });
    }
    createExternalSupport() {
        this.$store
            .dispatch("createExternalSupport", {
            userId: this.$data.selectedExternalSupportToCreate.id,
            from: this.$data.createExternalSupportDates.from,
            to: this.$data.createExternalSupportDates.to,
        })
            .then((result) => {
            this.fetchExternalSupport();
            this.$data.modals.createExternalSupport = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalSupportEditor.vue -> createExternalSupport");
        });
    }
    updateExternalSupport() {
        console.log("update this user: ", this.$data.selectedExternalSupport);
        this.$store
            .dispatch("updateExternalSupport", this.$data.selectedExternalSupport)
            .then((result) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: `The external support ${this.$data.selectedExternalSupport.firstName} ${this.$data.selectedExternalSupport.lastName} has been updated.`
            });
            this.$data.modals.editExternalSupport = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalSupportEditor.vue -> updateExternalSupport");
        });
    }
    deleteExternalSupport() {
        console.log("delete this user: ", this.$data.selectedExternalSupport);
        this.$store
            .dispatch("deleteExternalSupport", this.$data.selectedExternalSupport)
            .then((response) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: `The external support ${this.$data.selectedExternalSupport.firstName} ${this.$data.selectedExternalSupport.lastName} has been deleted.`
            });
            this.fetchExternalSupport();
            this.$data.showDeleteExternalSupportDialog = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalSupportEditor.vue - deleteExternalSupport");
        });
        this.$data.modals.editExternalSupport = false;
    }
    updateCreateUser(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "createUserDialog")
        this.$data.showCreateUserDialog = value;
    }
};
ExternalSupportEditor = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                loadingExternalSupport: true,
                filteredExternalSupport: null,
                externalSupport: null,
                onlyCurrentExternalSupport: true,
                userList: null,
                loadingUsers: true,
                createExternalSupportDates: { from: null, to: null },
                addExternalSupportModal: null,
                externalSupportHeaders: [
                    { text: "Email", value: "email" },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                ],
                showCreateUserDialog: false,
                showDeleteExternalSupportDialog: false,
                modals: {
                    createExternalSupport: false,
                    editExternalSupport: false,
                },
                selectedExternalSupportToCreate: null,
                selectedExternalSupport: null,
                selectedTarifftoAdd: [],
                tariffsDropdown: null,
                filter: "",
                tariffFilter: "",
                addexternalConsultantData: { email: "" },
                sortbyValue: "email",
                editHeaders: [
                    { text: "ID", value: "tariffId" },
                    { text: "Name", value: "tariffName" },
                    { text: "Customer", value: "customerName" },
                    { text: "Delete", value: "delete", sortable: false },
                ],
                tariffSelectHeaders: [
                    { text: "Customer", value: "customerName" },
                    { text: "Tariff", value: "name" },
                ],
                impersonateText: "Impersonate",
                selectedexternalConsultant: null,
                editexternalConsultantModal: false,
            };
        },
        created() {
            this.fetchExternalSupport();
        },
        watch: {
            filteredExternalSupport: function (val) {
                console.log("filteredExternalSupport", val);
            },
        },
        components: {
            WhiteBox,
            Modal,
            DatePickerTextbox,
            CreateUserDialog
        },
    })
], ExternalSupportEditor);
export default ExternalSupportEditor;
